import React from 'react'
import DataLoader from '../data/DataLoader'
import TeamMember from './TeamMember'
import TeamBioSection from './TeamBioSection'
import Footer from '../footer/Footer'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import MetaTags from 'react-meta-tags'

class TeamPage extends React.Component {

  constructor(){
    super();
    this.state = {
        selectedTeamMember: false,
        bioVisible: false
    }

    //this.selectTeamMember = this.selectTeamMember.bind(this)

    this.hideMember = this.hideMember.bind(this)
  }

  createMarkup(str) {
    return {__html: str};
  }


  showMember(id){

    let selectedTeamMember = this.props.peopleData.data.filter((item,index) => {
          return (item.id===id)
    })[0]

    this.setState({selectedTeamMember,bioVisible:true})

    //console.log(id,selectedTeamMember);
    console.log(document.querySelector('.page-wrapper').scrollTop);
    document.querySelector('.page-wrapper').scrollTop = this.refs.bioContainer.offsetTop-100;

    (document.querySelector('.copy-container'))?
      document.querySelector('.copy-container').scrollTop = 0
    : null ;

    console.log(  document.querySelector('.copy-container'));

    setTimeout(()=>{
        console.log(this.refs.bioContainer.offsetTop)
      }
    ,100);



  }

  componentDidMount(){
    setInterval(()=>{
          //console.log('check load',window);
    },100)

    const load = () => {
      console.log("load event detected!");
    }
    console.log(window);
    window.onloadeddata = load;

    this.refs.container.addEventListener("onload",()=>{ console.log("content loaded");})
  }

  hideMember(){
    this.setState({bioVisible:false})
  }


  render () {

      let content = this.props.content

      //console.log(this.props.peopleData);




      let peopleList;

      if(this.props.peopleData){
        peopleList = this.props.peopleData.data
        // HACK: To test the people list
          /*
          for(let i=0;i < 20 ; i++){
            peopleList.push(peopleList[0])
          };*/
      }



      return (
        <div className="standard-page team-page" ref="container">

          <MetaTags>
            <meta id="meta-description" name="description" content={content.acf.meta_description} />
            <title>{'The Fyzz - Facility | '+content.title.rendered}</title>
            <meta id="og-title" property="og:title" content={'The Fyzz - Facility | '+content.title.rendered} />
          </MetaTags>

          <section className="header content-row">
            <div className="inner">
              <h1 className="page-title" dangerouslySetInnerHTML={this.createMarkup(content.title.rendered)}></h1>
              <div className="intro" dangerouslySetInnerHTML={this.createMarkup(content.content.rendered)}></div>
            </div>
          </section>

          <div ref="bioContainer">
          {
            //(this.state.selectedTeamMember)?

                <TeamBioSection content={this.state.selectedTeamMember} open={this.state.bioVisible} closeHandler={this.hideMember}  />

            //: null
          }
          </div>

          <div className="team-list">

          <DataLoader load="people">


            {
              (this.props.peopleData)?
                this.props.peopleData.data.map((member,index)=>{
                      return <TeamMember key={'tm'+index} content={member} click={(e) => this.showMember(member.id)}  />

                })

            : null }



          </DataLoader>
          </div>
          <Footer></Footer>
        </div>
      )
  }
}

const mapStateToProps = (state)=>{

  const peopleData = state.peopleData

  return {
    peopleData
  }


}

export default withRouter(connect(mapStateToProps)(TeamPage));



// WEBPACK FOOTER //
// ./src/modules/teampage/TeamPage.js